const educationContent = [
  {
    year: '2019 - 2023',
    degree: 'BACHELOR OF ENGINEERING',
    institute: 'DAWOOD UET',
    details: `Specialized in core areas of computer science and engineering, with a strong focus on Programming, Data Structures and Algorithms (DSA), Software Engineering, Object-Oriented Programming (OOP), Web Designing, and Artificial Intelligence (AI).`,
  },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
